import type { FC, ReactNode } from 'react';
import { Spin } from 'antd';
import { useAppInit } from '@/hooks/init';
import { useAuth0 } from '@auth0/auth0-react';

const AppGuard: FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading: appInitLoading } = useAppInit();
  const { isLoading: auth0Loading } = useAuth0();
  const isLoading = appInitLoading || auth0Loading;

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100vw',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return <>{children}</>;
};

export default AppGuard;
